import * as React from 'react';

export const Sparkle16: React.FC = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='currentColor'>
			<path d='M7.657 1.378a.375.375 0 0 1 .686 0l1.449 3.397a.375.375 0 0 0 .213.213l3.397 1.449a.375.375 0 0 1 0 .686l-3.397 1.449a.375.375 0 0 0-.213.213L8.343 12.182a.375.375 0 0 1-.686 0L6.208 8.785a.375.375 0 0 0-.213-.213L2.598 7.123a.375.375 0 0 1 0-.686l3.397-1.449a.375.375 0 0 0 .213-.213L7.657 1.378zM12.1 9.534a.25.25 0 0 1 .457 0l.724 1.698a.25.25 0 0 0 .142.142l1.698.724a.25.25 0 0 1 0 .457l-1.698.724a.25.25 0 0 0-.142.142l-.724 1.698a.25.25 0 0 1-.457 0l-.724-1.698a.25.25 0 0 0-.142-.142l-1.698-.724a.25.25 0 0 1 0-.457l1.698-.724a.25.25 0 0 0 .142-.142l.724-1.698z' />
		</svg>
	);
};
